<template>
  <div>
    <!-- 面包屑 -->
    <el-breadcrumb separator-class="el-icon-arrow-right">
      <el-breadcrumb-item :to="{ path: '/mediate' }"
        >管理后台</el-breadcrumb-item
      >
      <el-breadcrumb-item>调解人员列表</el-breadcrumb-item>
    </el-breadcrumb>

    <el-card>
      <!-- 搜索栏 -->
      <el-row :gutter="10">
        <el-col :span="6">
          <el-input placeholder="输入姓名" v-model="queryInfo.name"></el-input>
        </el-col>
        <el-col :span="4">
          <el-button type="primary" @click="getMediatorsList">搜索</el-button>
        </el-col>
        <el-col :span="4">
          <el-button type="primary" @click="showAddDialog">添加</el-button>
        </el-col>
        <el-col :span="4">
          <!-- 【注意】:http-request 绑定的方法是 uploadExcelFile -->
          <el-upload action="https" :http-request="uploadExcelFile">
            <el-button size="small" type="primary">批量上传</el-button>
          </el-upload>
        </el-col>
        <el-col :span="4"
          ><el-button size="small" type="primary" @click="downLoadTemplate"
            >调解员模板下载</el-button
          >
        </el-col>
      </el-row>

      <!-- 调解人员列表 -->
      <el-table border stripe :data="mediators">
        <el-table-column type="index"></el-table-column>
        <el-table-column label="调解人员姓名" prop="name"></el-table-column>
        <el-table-column label="身份证号码" prop="id_number"></el-table-column>
        <el-table-column
          label="调解中心线路号码"
          prop="line_number"
        ></el-table-column>
        <el-table-column
          label="所属公司/机构名称"
          prop="org_name"
        ></el-table-column>
        <el-table-column label="项目名称" prop="project"></el-table-column>
        <el-table-column label="操作">
          <template slot-scope="scope">
            <el-button
              type="primary"
              icon="el-icon-edit"
              size="mini"
              @click="showEditDialog(scope.row)"
              >编辑</el-button
            >
            <el-button
              type="danger"
              icon="el-icon-delete"
              size="mini"
              @click="removeById(scope.row.id)"
              >删除</el-button
            >
          </template>
        </el-table-column>
      </el-table>

      <!-- 分页 -->
      <el-pagination
        @size-change="handleSizeChange"
        @current-change="handleCurrentChange"
        :current-page="queryInfo.pagenum"
        :page-sizes="[5, 10, 15, 20]"
        :page-size="queryInfo.pagesize"
        layout="total, sizes, prev, pager, next, jumper"
        :total="total"
      >
      </el-pagination>
    </el-card>

    <!-- 添加or编辑文章弹出层 -->
    <el-dialog
      :visible.sync="dialogVisble"
      width="50%"
      @close="addOrEditDialogClosed"
    >
      <el-form
        ref="addOrEditFormRef"
        :model="addOrEditForm"
        :rules="addOrEditFormRules"
        label-width="180px"
      >
        <el-form-item label="调解人员姓名">
          <el-input v-model="addOrEditForm.name"></el-input>
        </el-form-item>
        <el-form-item label="身份证号码">
          <el-input v-model="addOrEditForm.id_number"></el-input>
        </el-form-item>
        <el-form-item label="调解中心线路号码">
          <el-input v-model="addOrEditForm.line_number"></el-input>
        </el-form-item>
        <el-form-item label="所属公司/机构名称">
          <el-input v-model="addOrEditForm.org_name"></el-input>
        </el-form-item>
        <el-form-item label="项目名称">
          <el-input v-model="addOrEditForm.project"></el-input>
        </el-form-item>
        <el-form-item label="头像">
          <el-upload
            ref="uploadRef"
            :action="uploadURL"
            :on-preview="handlePreview"
            :on-remove="handleRemove"
            list-type="picture"
            :headers="headerObj"
            :on-success="handleSuccess"
            :limit="1"
          >
            <el-button size="small" type="primary">上传头像</el-button>
          </el-upload>
          <div class="existPic" v-if="addOrEditForm.pic">
            <img :src="avatarPreviewUrl" alt="头像预览" />
          </div>
        </el-form-item>
      </el-form>
      <span slot="footer" class="dialog-footer">
        <el-button @click="dialogVisble = false">取 消</el-button>
        <el-button type="primary" @click="addOrEdit">确 定</el-button>
      </span>
    </el-dialog>

    <!-- 图片预览 -->
    <el-dialog title="图片预览" :visible.sync="previewVisible" width="50%">
      <img :src="previewPath" alt="" class="previewImg" />
    </el-dialog>
  </div>
</template>

<script>
export default {
  name: "List",
  data() {
    return {
      dialogVisble: false,
      addOrEditForm: {
        id: -1,
        name: "",
        id_number: "",
        line_number: "",
        org_name: "",
        project: "",
        pic: "",
      },
      isEdit: false,
      addOrEditFormRules: {
        name: [{ required: true, message: "请输入姓名", trigger: "blur" }],
        id_number: [
          { required: true, message: "请输入身份证号码", trigger: "blur" },
        ],
        line_number: [
          { required: true, message: "请输入中心线路号码", trigger: "blur" },
        ],
        org_name: [
          { required: true, message: "请输入机构名称", trigger: "blur" },
        ],
        project: [
          { required: true, message: "请输入项目名称", trigger: "blur" },
        ],
      },
      mediators: [],
      queryInfo: {
        name: "",
        pagenum: 1,
        pagesize: 10,
      },
      total: 0,
      uploadURL: process.env.VUE_APP_BASE_API + "upload",
      headerObj: {
        Authorization: window.sessionStorage.getItem("token"),
      },
      previewPath: "",
      previewVisible: false,
    };
  },
  created() {
    this.getMediatorsList();
  },
  computed: {
    avatarPreviewUrl() {
      if (!this.addOrEditForm.pic) {
        return "";
      }
      return process.env.VUE_APP_BASE_API_DOMAIN + this.addOrEditForm.pic;
    },
  },
  methods: {
    showAddDialog() {
      this.isEdit = false;
      this.dialogVisble = true;
    },
    addOrEditDialogClosed() {
      this.$refs.addOrEditFormRef.resetFields();
      this.addOrEditForm.id = -1;
      this.addOrEditForm.name = "";
      this.addOrEditForm.id_number = "";
      this.addOrEditForm.line_number = "";
      this.addOrEditForm.org_name = "";
      this.addOrEditForm.project = "";
      this.addOrEditForm.pic = "";
      if (this.$refs.uploadRef) {
        this.$refs.uploadRef.clearFiles();
      }
    },
    addOrEdit() {
      if (!this.isEdit) {
        this.addMediator();
      } else {
        this.editMediator();
      }
    },
    addMediator() {
      this.$refs.addOrEditFormRef.validate(async (valid) => {
        if (!valid) return;
        const { data: res } = await this.$http.post(
          "mediator",
          this.addOrEditForm
        );
        if (res.meta.status !== 201) {
          return this.$message.error("添加失败！");
        }
        this.$message.success("添加成功！");
        this.getMediatorsList();
        this.dialogVisble = false;
      });
    },
    editMediator() {
      this.$refs.addOrEditFormRef.validate(async (valid) => {
        if (!valid) return;
        const { data: res } = await this.$http.put(
          `mediator/${this.addOrEditForm.id}`,
          this.addOrEditForm
        );
        if (res.meta.status !== 200) {
          return this.$message.error("修改失败！");
        }
        this.$message.success("修改成功！");
        this.getMediatorsList();
        this.dialogVisble = false;
      });
    },
    async getMediatorsList() {
      const { data: res } = await this.$http.get("mediator", {
        params: this.queryInfo,
      });
      if (res.meta.status !== 200) {
        return this.$message.error("获取调解员列表失败！");
      }
      this.$message.success("获取调解员列表成功！");
      this.mediators = res.data.mediators;
      for (var m of this.mediators) {
        if (m.pic) {
          m.pic = `${process.env.VUE_APP_BASE_API_DOMAIN}${m.pic}`;
        }
      }
      this.total = res.data.total;
    },
    handleSizeChange(newSize) {
      this.queryInfo.pagesize = newSize;
      this.getMediatorsList();
    },
    handleCurrentChange(newPage) {
      this.queryInfo.pagenum = newPage;
      this.getMediatorsList();
    },
    async removeById(id) {
      const confirmResult = await this.$confirm(
        "此操作将永久删除该文章, 是否继续?",
        "提示",
        {
          confirmButtonText: "确定",
          cancelButtonText: "取消",
          type: "warning",
        }
      ).catch((err) => err);
      if (confirmResult !== "confirm") {
        return this.$message.info("已经取消删除！");
      }
      const { data: res } = await this.$http.delete(`mediator/${id}`);
      if (res.meta.status !== 200) {
        return this.$message.error("删除失败！");
      }
      this.$message.success("删除成功！");
      this.getMediatorsList();
    },
    showEditDialog(row) {
      this.dialogVisble = true;
      this.isEdit = true;
      this.addOrEditForm.id = row.id;
      this.addOrEditForm.name = row.name;
      this.addOrEditForm.id_number = row.id_number;
      this.addOrEditForm.line_number = row.line_number;
      this.addOrEditForm.org_name = row.org_name;
      this.addOrEditForm.project = row.project;
      if (row.pic) {
        this.addOrEditForm.pic = row.pic.replace(
          process.env.VUE_APP_BASE_API_DOMAIN,
          ""
        );
      } else {
        this.addOrEditForm.pic = "";
      }
    },
    // 【修复 1】: 将参数重命名为 options，使其更清晰
    async uploadExcelFile(options) {
      let formdata = new FormData();
      // 从 options 对象中获取文件
      formdata.append("file", options.file);
      await this.$http.post("/mediator/upload", formdata, {
        "Content-type": "multipart/form-data",
      });
      this.$message.success("导入成功！");
      this.getMediatorsList();
    },
    downLoadTemplate() {
      let a = document.createElement("a");
      a.href = "static/mediator.xlsx";
      a.download = "mediator.xlsx";
      a.style.display = "none";
      document.body.appendChild(a);
      a.click();
      document.body.removeChild(a);
    },
    handlePreview(file) {
      if (file.response) {
        this.previewPath =
          process.env.VUE_APP_BASE_API_DOMAIN + file.response.data.url;
      } else {
        this.previewPath = file.url;
      }
      this.previewVisible = true;
    },
    // 【修复 2】: 添加 eslint-disable-next-line 注释来忽略此行的 no-unused-vars 错误
    // eslint-disable-next-line no-unused-vars
    handleRemove(file, fileList) {
      this.addOrEditForm.pic = "";
    },
    handleSuccess(response) {
      this.addOrEditForm.pic = response.data.tmp_path;
    },
  },
};
</script>

<style scoped>
.previewImg {
  width: 100%;
}
.existPic {
  width: 150px;
  height: 150px;
  margin-top: 10px;
}
.existPic img {
  width: 100%;
  height: 100%;
  object-fit: cover;
}
</style>